import {
    CollaboratorsActionTypes,
    IAddCollaboratorAction,
    IAddCollaboratorWithTempIdAction,
    IDeleteCollaboratorAction,
    IChangeCollaboratorRoleAction,
} from "./types";
import { ActionCreator } from "../types/store-types";

export const addCollaborator: ActionCreator<IAddCollaboratorAction> = payload => ({
    type: CollaboratorsActionTypes.ADD,
    payload,
});

export const addCollaboratorWithTempId: ActionCreator<IAddCollaboratorWithTempIdAction> = payload => ({
    type: CollaboratorsActionTypes.ADD_WITH_TEMP_ID,
    payload,
});

export const deleteCollaborator: ActionCreator<IDeleteCollaboratorAction> = payload => ({
    type: CollaboratorsActionTypes.DELETE,
    payload,
});

export const changeCollaboratorRole: ActionCreator<IChangeCollaboratorRoleAction> = payload => ({
    type: CollaboratorsActionTypes.CHANGE_ROLE,
    payload,
});
